module.exports = __webpack_public_path__ + "static/media/PH.20b3ffa1.png";